// @import './../../../../../styles/global/global-imports';

:host {
  display: block;
}
